export default __webpack_public_path__ + "static/media/welcome_aknote@2x.2bbfe441.png";